

































































































import Vue from 'vue';
import { Resolve } from 'vue-di';
import { Component, Prop } from 'vue-property-decorator';
import EligibilityModule from '~/store/eligibility';
import EnrollmentModule from '~/store/enrollment';

@Component<Header>({})
export default class Header extends Vue {
    @Prop()
    public brkPoints!: object;

    @Resolve
    enrollment!:EnrollmentModule;

    @Resolve
    eligibility!: EligibilityModule;

    handleClick() {
        this.$vuetify.goTo('#static-footer', {
            duration: 1000,
            easing: 'easeInOutCubic',
            offset: 70,
        });
    }

    handleLogoClick() {
        this.enrollment.clearStore();
        this.enrollment.clearEnrollment();
        this.eligibility.clearEligibilityData();
    }
}
